<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { container } from './core/ioc/Container'
import { authService } from './core/sso/oidc/AuthService'
import { useLayout } from './layout/composables/layout'
import { ApiClient } from './service/ApiClient'
import { SERVICES_TYPES } from './service/ServicesTypes'
import { useLocaleStore } from './stores/LocaleStore'
import { useThemeStore } from './stores/ThemeStore'

const { locale } = useI18n()
const { layoutConfig, toggleDarkMode } = useLayout()
const localStore = useLocaleStore()
const themeStore = useThemeStore()
const router = useRouter()
const route = useRoute()

const redirectToLogin = async () => {
  if (import.meta.env.MODE !== 'ci' && !(await authService.checkAuthentication())) {
    router.push(`/login?redirect=${route.fullPath}`)
  }
}

onBeforeMount(() => {
  locale.value = localStore.Locale
  layoutConfig.darkTheme !== themeStore.DarkTheme && toggleDarkMode()

  if (container.isBound(SERVICES_TYPES.ApiClient)) {
    container.unbind(SERVICES_TYPES.ApiClient)
  }

  container.bind<ApiClient>(SERVICES_TYPES.ApiClient).toConstantValue(new ApiClient(redirectToLogin))
})
</script>

<template>
  <router-view />
</template>
